/* Sika Design 3D generator: Share configuration (20 Oct 2026, Dee approved the mock-up).
   Desktop: "Share configuration" tab above "Download images" (same style, left edge); click copies the link and opens a small card
   (Link copied / Send by email / Copy again). Phone: compact "Share" tab at the bottom-right of the 3D view; tap opens the phone's
   own share menu (navigator.share), falling back to copy + card. The link itself comes from window.cpgShareLink() in
   sections/custom-product-generator.liquid (same record as the saved selection). */
(function () {
  var DESK = '(min-width: 1200px), (min-width: 768px) and (orientation: landscape)';
  var ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M12 15V3M7.5 7.5 12 3l4.5 4.5"/><path d="M5 11v9h14v-9"/></svg>';
  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6"/></svg>';

  function copyText(s) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(s).then(function () { return true; }, function () { return legacy(s); });
    return Promise.resolve(legacy(s));
    function legacy(v) {
      try {
        var ta = document.createElement('textarea'); ta.value = v; ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:-1000px;opacity:0'; document.body.appendChild(ta); ta.select();
        var ok = document.execCommand('copy'); ta.remove(); return ok;
      } catch (e) { return false; }
    }
  }

  function init(root) {
    if (root.__cpgShare) return;
    var mv = root.querySelector('model-viewer');
    if (!mv || typeof window.cpgShareLink !== 'function') return;
    root.__cpgShare = true;
    var host = mv.closest('.cpg__grid') || mv.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var tab = document.createElement('button');
    tab.type = 'button'; tab.className = 'cpg-snap__tab cpg-share__tab';
    tab.innerHTML = ICON + '<span>Share configuration</span>';   /* same order as Download images, so the theme CSS places the icon the same way */
    host.appendChild(tab);

    var pop = document.createElement('div');
    pop.className = 'cpg-share__pop'; pop.hidden = true; pop.setAttribute('role', 'status');
    pop.innerHTML = '<p class="cpg-share__ok">' + CHECK + '<span data-t>Link copied</span></p>' +
      '<p class="cpg-share__txt">Anyone with the link sees this exact chair and can keep editing it.</p>' +
      '<input class="cpg-share__url" type="text" readonly hidden aria-label="Link to this configuration">' +
      '<p class="cpg-share__links"><a class="cpg-share__link" data-mail href="#">Send by email</a><button type="button" class="cpg-share__link is-soft" data-again>Copy again</button></p>';
    host.appendChild(pop);

    function dl() { return host.querySelector('.cpg-snap__tab:not(.cpg-share__tab)'); }
    function desk() { return matchMedia(DESK).matches; }

    function place() {
      var hr = host.getBoundingClientRect(), mr = mv.getBoundingClientRect(), d = dl(), D = desk();
      tab.classList.toggle('is-right', !D);
      tab.querySelector('span').textContent = D ? 'Share configuration' : 'Share';
      if (D) {
        tab.style.right = 'auto';
        tab.style.left = d ? d.style.left : '0px';
        tab.style.paddingLeft = d ? d.style.paddingLeft : '';
        var top = d ? d.offsetTop - tab.offsetHeight - 12 : Math.round(mr.bottom - hr.top - tab.offsetHeight * 2 - 36);
        tab.style.top = top + 'px';
      } else {
        var vw = document.documentElement.clientWidth;
        tab.style.left = 'auto'; tab.style.paddingLeft = '';
        tab.style.right = -Math.max(0, Math.round(vw - hr.right)) + 'px';
        /* 20 Oct 2026 (Dee): the pill's top edge on the top of the "Selected materials" text */
        var head = root.querySelector('.cpg__data-head');
        if (head && head.offsetParent) {
          var rg = document.createRange(); rg.selectNodeContents(head); var b = rg.getBoundingClientRect();
          var fs = parseFloat(getComputedStyle(head).fontSize) || 16, inkTop = b.top + (b.height - fs) / 2 + fs * 0.12;
          tab.style.top = Math.round(inkTop - hr.top) + 'px';
        } else tab.style.top = Math.round(mr.bottom - hr.top - tab.offsetHeight - 12) + 'px';
      }
      if (!pop.hidden) placePop();
    }
    function placePop() {
      if (desk()) {
        pop.style.right = 'auto';
        pop.style.left = (tab.offsetLeft + tab.offsetWidth + 14) + 'px';
        pop.style.top = Math.max(0, tab.offsetTop + tab.offsetHeight - pop.offsetHeight) + 'px';
      } else {
        pop.style.left = 'auto'; pop.style.right = '0px';
        pop.style.top = Math.max(0, tab.offsetTop - pop.offsetHeight - 10) + 'px';
      }
    }
    function later() { requestAnimationFrame(place); }
    if (window.ResizeObserver) new ResizeObserver(later).observe(host);
    window.addEventListener('resize', later);
    mv.addEventListener('load', later);
    var watch = setInterval(function () {
      var d = dl();
      if (d) { clearInterval(watch); if (window.MutationObserver) new MutationObserver(later).observe(d, { attributes: true, attributeFilter: ['style', 'class'] }); later(); }
    }, 250);
    setTimeout(function () { clearInterval(watch); }, 15000);
    later();

    function closePop() { pop.hidden = true; }
    function openPop(url, ok) {
      var title = window.cpgShareTitle();
      pop.querySelector('[data-t]').textContent = ok ? 'Link copied' : 'Copy this link';
      pop.querySelector('.cpg-share__ok svg').style.display = ok ? '' : 'none';
      var inp = pop.querySelector('.cpg-share__url'); inp.value = url; inp.hidden = !!ok;
      pop.querySelector('[data-mail]').href = 'mailto:?subject=' + encodeURIComponent(title + ' | Sika Design') +
        '&body=' + encodeURIComponent('See my ' + title + ' configuration:\n' + url);
      pop.hidden = false; placePop();
      if (!ok) { inp.focus(); inp.select(); }
    }
    async function share() {
      var url = window.cpgShareLink(), title = window.cpgShareTitle();
      if (!desk() && navigator.share) {
        /* url + title only (20 Oct 2026, Dee): with a text the phone's "Copy" put the sentence in front of the link */
        try { await navigator.share({ title: title + ' | Sika Design', url: url }); } catch (e) {}
        return;
      }
      var ok = await copyText(url);
      openPop(url, ok);
    }
    tab.addEventListener('click', function (e) { e.stopPropagation(); share(); });
    pop.addEventListener('click', function (e) { e.stopPropagation(); });
    pop.querySelector('[data-again]').addEventListener('click', function () {
      var url = window.cpgShareLink(); copyText(url).then(function (ok) { openPop(url, ok); });
    });
    pop.querySelector('[data-mail]').addEventListener('click', function () { setTimeout(closePop, 300); });
    document.addEventListener('click', function () { if (!pop.hidden) closePop(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.cpg'), function (r) { if (r.querySelector('model-viewer')) init(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
  setTimeout(boot, 1500);
})();
